export enum SupportedCountry {
  US = "US",
  GB = "GB",
  AU = "AU",
  BH = "BH",
  OM = "OM",
  IE = "IE",
  CA = "CA",
  IQ = "IQ",
  AE = "AE",
  QA = "QA",
  SA = "SA",
  KW = "KW",
}
